import { ref } from 'vue'
import { defineStore } from 'pinia'
import { $t } from '@previo/core'
import { toast } from '@previo/design-system'
import { useAPI } from '~/http'
import { StoreKey } from '~/store/StoreKey'
import type { Property, PropertyListResponse } from '~/http/property/types'

export const usePropertiesStore = defineStore(StoreKey.PROPERTIES, () => {
  const properties = ref<Property[]>([])
  const loading = ref<boolean>(false)

  const loadProperties = () => {
    loading.value = true

    useAPI()
      .propertyAPI.loadProperties()
      .then((r: PropertyListResponse) => {
        properties.value = r.properties
      })
      .catch(() => {
        toast.warning($t('Unable to load properties'))
      })
      .finally(() => {
        loading.value = false
      })
  }

  const findById = (propertyId: number): Property | null => {
    return properties.value.find((p: Property) => p.id === propertyId) || null
  }

  return {
    properties,
    loading,
    loadProperties,
    findById,
  }
})
